<template lang="html">
  <div class="inner-modal">
		<div class="head-modal spaced-row">
			<div>
				<div class="head-modal-title">
					{{ (isEdit) ? 'Editer' : 'Ajouter' }} un client
				</div>
				<div class="head-modal-emphase">
					Modifiez les informations d’un client ou ajoutez en un.
				</div>
			</div>
			<!-- <div class="row">
				<div class="head-modal-label">ACTIVATION</div>
				<toggle-input :value="user.enabled" @change="user.enabled = !user.enabled" />
			</div> -->
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('firstname')}">
							<label for="firstname">Prénom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="firstname" v-model="user.first_name">
						</div>
						<div v-if="errors.has('firstname')" class="error-message">{{ errors.first('firstname') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('name')}">
							<label for="name">Nom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="name" v-model="user.last_name">
						</div>
						<div v-if="errors.has('name')" class="error-message">{{ errors.first('name') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('company')}">
							<label for="company">Nom Entreprise</label>
							<input type="text" name="company" v-model="user.company_name">
							<!-- <input v-validate="'required|alpha'" type="text" name="company" v-model="user.company"> -->
						</div>
						<div v-if="errors.has('company')" class="error-message">{{ errors.first('company') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('siret')}">
							<label for="siret">Siret Entreprise</label>
							<input type="text" name="siret" v-model="user.company_siret">
							<!-- <input v-validate="'required|length:14'" type="text" name="siret" v-model="user.siret"> -->
						</div>
						<div v-if="errors.has('siret')" class="error-message">{{ errors.first('siret') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('address')}">
							<label for="address">Adresse du client</label>
							<input v-validate="'required'" type="text" name="address" v-model="user.address">
						</div>
						<div v-if="errors.has('address')" class="error-message">{{ errors.first('address') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('zipcode')}">
							<label for="postalcode">Code postal</label>
							<input v-validate="'required|length:5'" type="text" name="zipcode" v-model="user.zipcode">
						</div>
						<div v-if="errors.has('zipcode')" class="error-message">{{ errors.first('zipcode') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('city')}">
							<label for="city">Ville</label>
							<input v-validate="'required|alpha_spaces'" type="text" name="city" v-model="user.city">
						</div>
						<div v-if="errors.has('city')" class="error-message">{{ errors.first('city') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input form-elem-container ctn-select ctn-label" v-selectUI :class="{error: errors.has('country')}">
							<label for="select">Pays</label>
							<custom-select
								v-model="user.country"
								:items="countries"
								v-validate="'required'"
    						data-vv-name="country"
    						:has-error="errors.has('country')"
							></custom-select>
						</div>
						<div v-if="errors.has('country')" class="error-message">{{ errors.first('country') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('phone')}">
							<label for="phone">Téléphone</label>
							<input v-validate="'required|numeric|length:10'" type="phone" name="phone" v-model="user.phone">
						</div>
						<div v-if="errors.has('phone')" class="error-message">{{ errors.first('phone') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('date de naissance')}">
							<label class="active" for="date de naissance">Date de naissance</label>
							<input v-validate="'required'" type="date" name="date de naissance" v-model="user.birthdate">
						</div>
					</div>
				</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email')}">
					<label for="email">Adresse mail</label>
					<input v-validate="'required|email'" type="email" name="mail" v-model="user.email">
				</div>
				<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
				<div v-if="errors.has('password')" class="error-message">{{ errors.first('password') }}</div>
        <div class="ctn-duo-input row" v-if="isSuperAdmin">
        	<div class="left inner-duo">
						<div class="ctn-input form-elem-container ctn-select ctn-label" v-selectUI :class="{error: errors.has('office')}">
							<label for="select">Cabinet du client</label>
							<custom-select
								v-model="user.office"
								:items="cabinetsNames"
								v-validate="'required'"
								data-vv-value-path="mutableValue"
    							data-vv-name="office"
    							:has-error="errors.has('office')"
							></custom-select>
						</div>
						<div v-if="errors.has('office')" class="error-message">{{ errors.first('office') }}</div>
					</div>
        </div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="validateBeforeSubmit">Enregistrer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import countries from '@/fixtures/countries'
import { Validator } from 'vee-validate'

Validator.extend('alpha_dash_spaces', {
	getMessage: field => 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces',
	validate: value => {
		for (let i = 0; i < value.length; i++) {
			if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) { return false }
		}
		return true
	}
})
// const DEFAULT_USER = {
// 	first_name: "Raymond",
// 	last_name: "Tabernoux",
// 	phone: "0123457890",
// 	email: "r.tabernoux@test.fr",
// 	address: "5 rue des cocotiers",
// 	zipcode: "99999",
// 	city: "Paris",
// 	company: "Company",
// 	siret: "12345678912345",
// 	country: null,
// 	office: null,
// }

export default {
	name: 'AddClient',
	props: ['data'],
	data () {
		return {
			cabinets: [],
			countries,
			isEdit: false,
			user: {
				first_name: "",
				last_name: "",
				phone: "",
				email: "",
				address: "",
				zipcode: "",
				city: "",
        company_siret: null,
        company_name: null,
        country: null,
        office: null,
				birthdate: null
			}
		}
	},
	beforeMount () {
		this.$store.dispatch('getCabinets').then(() => {
			this.cabinets = this.$store.getters['cabinets']
		})

		if (this.data) {
			this.user = this.data.user
			this.user.company_siret = this.data.company_siret
			this.user.company_name = this.data.company_name
		}
	},
	mounted () {
		if (this.data) {
			this.isEdit = (this.data.id)
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		submit () {
      let officeId = null;
      if (this.isSuperAdmin) {
        officeId = this.cabinets.find(cabinet => cabinet.name === this.user.office).id
      } else {
        officeId = this.officeId
      }

      this.$store.commit('LOADER_IN')

			const userToSend = {
				'first_name': this.user.first_name,
        'last_name': this.user.last_name,
        'email': this.user.email,
        'office_id': officeId,
        'phone': this.user.phone,
        'address': this.user.address,
        'zipcode': this.user.zipcode,
        'city': this.user.city,
        'country': this.user.country,
        'company_name': this.user.company_name,
        'company_siret': this.user.company_siret,
				'birthdate': this.user.birthdate
			}

			if (this.isEdit) {
				userToSend['user_id'] = this.user.id
			}

			const promise = (this.isEdit) ?	this.$store.dispatch('editClient', userToSend) : this.$store.dispatch('addClient', userToSend)
			promise.then(() => {
				this.close()
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				})
			}).finally(() => {
				this.$store.commit('LOADER_OUT')
			})
		},
		validateBeforeSubmit () {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.submit()
					return
				}
			});
		}
	},
	computed: {
		cabinetsNames () {
			return this.cabinets ? this.cabinets.map(cabinet => cabinet.name) : []
		},
    ...mapGetters({
      isSuperAdmin: 'isSuperAdmin',
      officeId: 'officeId',
    })
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ClientModal.vue?f50e21de